export default "__VITE_PUBLIC_ASSET__6ccbd6e1__"